import type {
	Cartography,
	CartographyReportData,
	CartographyWithNodesAndRelationships,
	NodeIdsWithPos,
	NodesWithRelationships
} from '@graphit/types'
import axios from 'axios'

import env from '../environments'

export async function getCartographies() {
	const response = await axios.get(`${env.apiUrl}/cartographies`)

	return response.data as Cartography[]
}

export async function getCartography(id: string) {
	const response = await axios.get(`${env.apiUrl}/cartographies/${id}`)

	return response.data as CartographyWithNodesAndRelationships
}

export async function createCartography(cartographyName: string) {
	const response = await axios.post(`${env.apiUrl}/cartographies/create`, {
		cartographyName
	})

	return response.data as Cartography
}

export async function importNodes(
	cartograhyId: string,
	params: {
		nodeIds?: string[] | undefined
		labelId?: string | undefined
		typeId?: string | undefined
	}
) {
	const response = await axios.post(`${env.apiUrl}/cartographies/import/${cartograhyId}`, params)

	return response.data as NodesWithRelationships
}

export async function duplicateCartography(id: string) {
	const response = await axios.get(`${env.apiUrl}/cartographies/duplicate/${id}`)

	return response.data as Cartography
}

export async function getReportData(id: string) {
	const response = await axios.get(`${env.apiUrl}/cartographies/report/${id}`)

	return response.data as CartographyReportData
}

export async function importWorkspace(cartograhyId: string, workspaceId: string) {
	const response = await axios.post(`${env.apiUrl}/cartographies/import/${cartograhyId}/${workspaceId}`)

	return response.data as CartographyWithNodesAndRelationships
}

export async function removeNodes(cartograhyId: string, nodeIds: string[]) {
	return axios.post(`${env.apiUrl}/cartographies/remove/${cartograhyId}`, {
		nodeIds
	})
}

export async function unlockCartographyPosition(cartograhyId: string) {
	return axios.post(`${env.apiUrl}/cartographies/position/${cartograhyId}/unlock`)
}

export async function updateCartography(id: string, cartography: Partial<Cartography>) {
	await axios.put(`${env.apiUrl}/cartographies/${id}`, {
		cartography
	})
}

export async function updateNodePosition(id: string, node: NodeIdsWithPos) {
	await axios.put(`${env.apiUrl}/cartographies/nodePos/${id}`, {
		node
	})
}

export async function deleteCartography(id: string) {
	await axios.delete(`${env.apiUrl}/cartographies/${id}`)
}

export async function getPublicCartography(id: string) {
	const response = await axios.get(`${env.apiUrl}/public/cartographies/${id}`)

	return response.data as CartographyWithNodesAndRelationships
}

export async function toggleCartographySharable(id: string, isPublic: boolean) {
	const response = await axios.put(`${env.apiUrl}/cartographies/${id}/toggle-sharable`, { isPublic })

	return response.data as { isPublic: boolean }
}
